import Immutable from 'immutable';

import { hexEncode, hexDecode } from 'sharedreact/utils/Encode';

const Content: {
  objType: string,
  hex: string
} = {
  objType: 'DataBlock',
  hex: ''
};

class DataBlock extends Immutable.Record(Content) {
  get data (): string {
    return hexDecode(this.hex);
  }

  setData (dataString: string): DataBlock {
    return this.set('hex', hexEncode(dataString));
  }
}

export default DataBlock;
